<template>
  <!-- 发布帖子 -->
  <el-dialog :title="$t('我要投稿')" width="726px" top="8vh" :visible.sync="isVisible" @close="closeModal">

    <el-form ref="ruleForm" :inline="true" :rules="rules" :model="form">

      <el-row :gutter="20" class="mb-16">
        <el-col :span="12">
          <el-form-item :label="$t('姓名')" prop="user_name">
            <el-input v-model="form.user_name" :placeholder="$t('请输入')" name="user_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('昵称')" prop="user_nick_name">
            <el-input v-model="form.user_nick_name" :placeholder="$t('请输入')" name="user_nick_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('电话')" prop="user_contact_mobile">
            <el-input v-model="form.user_contact_mobile" :placeholder="$t('请输入')" name="user_contact_mobile"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('邮箱')" prop="user_contact_email">
            <el-input v-model="form.user_contact_email" :placeholder="$t('请输入')" name="user_contact_email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('文章标题')" prop="teba_title">
            <el-input v-model="form.teba_title" :placeholder="$t('请输入')" name="teba_title"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('行业')" prop="teba_hy_dd_id">
            <el-select v-model="form.teba_hy_dd_id" :placeholder="$t('请选择行业')" name="teba_hy_dd_id">
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in data.post_ins_list"
                :key="index"></el-option>

            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('领域')" prop="teba_cj_dd_id">
            <el-select v-model="form.teba_cj_dd_id" :placeholder="$t('请选择领域')" name="teba_cj_dd_id">
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in data.post_scene_list"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <Editor v-model="form.teba_content" :height="500" :isUseOss="true" />

      <!-- 上传附件 -->

      <div class="mt-14">

        <Upload v-model="form.teba_annex" upType="FILEARR"
          :fileType='["pdf", "mp4", "txt", "doc", "docx", "xls", "xlsx", "ppt", "pptx"]' :isUseOss="true"
          :key="componentKey" />
        <!-- <Upload v-model="form.teba_annex" upType="FILEARR" :isUseOss="true" /> -->
      </div>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal" class="btn1">{{ $t('取消') }}</el-button>
      <el-button type="primary" class="btn2" @click="submitPost">{{ $t('确认') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TinyMCEEditor from '@/components/Tinymce/index.vue';
import Editor from '@/components/Editor/index.vue';
import Upload from "@/components/Upload/index";
import { getMyInfo } from "@api/home";


export default {
  components: {
    TinyMCEEditor, Editor, Upload
  },
  props: {
    data: {
      type: Object|Array, // 指定参数类型
      required: true // 是否为必需参数
    }
  },
  data() {
    return {
      isVisible: false,
      postContent: '',
      userinfo: [],
      form: {
        user_name:"", 
        user_nick_name: "", //姓名
        user_contact_mobile: "", //电话
        user_contact_email: "", //邮箱
        teba_title: "",//标题
        // 行业
        teba_hy_dd_id: "",
        // 场景
        teba_cj_dd_id: "",
        teba_content: '',  //内容
        teba_annex: '',//附件
        // other_lang: [],
        // is_expert: [10],
        // user_expert: 20,
      },

      rules: {
        user_name: [
          { required: true, message: this.$t('请输入姓名'), trigger: 'blur' }
        ],
        user_nick_name: [
          { required: true, message: this.$t('请输入昵称'), trigger: 'blur' }
        ],
        user_contact_mobile: [
          { required: true, message: this.$t('请输入电话'), trigger: 'blur' }
        ],
        user_contact_email: [
          { required: true, message: this.$t('请输入邮箱'), trigger: 'blur' }
        ],
        teba_title: [
          { required: true, message: this.$t('请输入文章标题'), trigger: 'blur' }
        ],
        teba_hy_dd_id: [
          { required: true, message: this.$t('请选择行业'), trigger: 'change' },
        ],
        teba_cj_dd_id: [
          { required: true, message: this.$t('请选择领域'), trigger: 'change' },
        ],
        teba_content: [
          { required: true, message: this.$t('请填写正确的文章内容'), trigger: 'blur' }
        ],

      },

      componentKey: 1,
    };
  },
  watch: {
    // 监听isVisible属性变化，当isVisible为true时，重新获取用户信息
    isVisible(newVal) {
      if (newVal) {
        this.getCurrUserData();
      } 
    },
    data: function(newData) {
      this.form.other_lang = newData.other_lang.map((lang) => lang.tws_id)
    }
  },
  mounted() {
    // 获取个人信息
    this.getCurrUserData();
  },
  methods: {
    async getCurrUserData() {
      // 获取用户信息，本地是否有缓存，有就直接使用，没有就请求接口
      if (localStorage.getItem('userinfo')) {
        this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
      }else{
        let res = await getMyInfo();
        if (res.status == 200) {
          this.userinfo = res.data;
        }
      }
      this.form.user_name = this.userinfo.user_name
      this.form.user_nick_name = this.userinfo.user_nick_name
      this.form.user_contact_mobile = this.userinfo.user_contact_mobile
      this.form.user_contact_email = this.userinfo.user_contact_email
      this.form.user_id = this.userinfo.user_id
    },

    // 打开弹窗
    openModal() {
      this.isVisible = true;
      this.componentKey = 1;  //附件key值重置
    },

    // 关闭弹窗
    closeModal() {
      this.isVisible = false;
      this.$refs['ruleForm'].clearValidate();
      this.$refs['ruleForm'].resetFields();

      setTimeout(() => {
        this.componentKey = 2;
        this.form = {
          user_name: "", //姓名
          user_nick_name: "", //昵称
          user_contact_mobile: "", //电话
          user_contact_email: "", //邮箱
          teba_title: "",//标题
          // 行业
          teba_hy_dd_id: "",
          // 场景
          teba_cj_dd_id: "",
          teba_content: '',  //内容
          teba_annex: '',//附件
        }
      }, 200);

    },
    submitPost() {

      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.form.teba_content.trim()) {
            this.$message.error(this.$t('请填写正确的文章内容'));
            return false;
          }
          this.$emit('ebook-submitted', this.form);
          setTimeout(() => {
              this.closeModal();
            }, 20);

            var _this = this;
            setTimeout(() => {
              _this.form = {
                user_name: "", //姓名
                user_nick_name: "", //昵称
                user_contact_mobile: "", //电话
                user_contact_email: "", //邮箱
                teba_title: "",//标题
                // 行业
                teba_hy_dd_id: "",
                // 场景
                teba_cj_dd_id: "",
                teba_content: '',  //内容
                teba_annex: '',//附件
              }
            }, 500);
        } else {
          // 验证不通过,滚动到第一个错误的表单字段
          const firstErrorField = this.$refs.ruleForm.fields.find(field => field.validateState === 'error');
          const errorElement = document.getElementsByName(firstErrorField.prop)[0];
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

      })


    }
  }
};
</script>

<style scoped lang="scss">
.languige-text {
  font-size: 14px;
  font-weight: 400;
  color: rgb(25, 25, 25);
  line-height: 24px;
  margin-top: 4px;

  ::v-deep() {
    .el-checkbox__label {
      font-family: "harmonyos";
      color: #191919;
    }
  }
}

::v-deep() {
  .el-dialog__header {
    padding: 28px 32px 0px;
  }
  .el-form-item__error {
    padding-top: 0;
    top: calc(100% - 1px);
  }

  .el-form-item__label {
    line-height: 26px;
  }

  .dialog-footer {

    .btn1,
    .btn2 {
      min-width: 76px;
      height: 36px;
      border-radius: 30px;
      padding: 0 16px;
      font-size: 14px;
    }

    .btn1 {
      background-color: #ffffff;
      border: 1px solid #ededed;

      &:hover {
        border: 1px solid #d9462f;
      }
    }

    .btn2 {
      // background-color: #D64F31;
      background: linear-gradient(to right, #eb6f54, #d9462f);
      border: none;

      &:hover {
        background: linear-gradient(to right, #d9462f, #d9462f);
      }
    }
  }

  .el-form-item__label-wrap {
    float: none;
  }

  .el-form--inline .el-form-item {
    width: 100%;
    margin-bottom: 10px;

    .el-input__inner {
      line-height: 34px;
      height: 34px;
      font-size: 14px;
    }

  }

  .el-form--inline .el-form-item__content,
  .el-select {
    width: 100%;
  }

  .el-dialog {
    border-radius: 12px;
  }

  .el-dialog__body {
    padding: 20px 30px 30px;
    // padding-top: 4px;
    max-height: calc(84vh - 120px);
    overflow-y: scroll;
    // padding: 0px 12px 0 36px;

    // 滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      /* 滚动条宽度 */
      height: 8px;
      /* 滚动条高度 */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #B7251E;
      /* 滚动条颜色 */
      border-radius: 6px;
      /* 滚动条圆角 */
    }

    &::-webkit-scrollbar-track {
      background-color: #ffffff;
      /* 滚动条轨道颜色 */
    }
  }
}
</style>